import React, { useRef, useState, useEffect } from "react";
import LoginBg from "../images/login-bg.png"
import Logo from "../images/logo.png"
import Shape from "../images/login-shape.png"
import Eye from "../images/eye.png"
import "../css/style.css";
import "../css/responsive.css";
import "../css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';
import callingAPI, { callingAPIWithoutAuth } from "../service";
import ChangePassword from "../pages/changePassword"
import ForgotPassword from "../pages/forgotPassword"
import HideEye from "../images/hide.png"
import Disclaimer from "./disclaimer"
import TermsServicePopup from "./terms-and-service-popup"
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch } from "react-redux";
import { setDashboardData, clearDashboardData } from "../redux/reducers/dashboardSlice";

export default function Login() {
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showOtpField, setShowOtpField] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpValidated, setOtpValidated] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [isTermsServiceModalOpen, setIsTermsServiceModalOpen] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // Store acceptTermsAndCondition from login API
    const [acceptTermsAndCondition, setAcceptTermsAndCondition] = useState(null);

    const recaptchaRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    useEffect(() => {
        dispatch(clearDashboardData());
        dispatch(
            setDashboardData({
                moduleId: 10,
            })
        );
    }, [])

    // Enhanced error handling for reCAPTCHA
    const handleCaptchaError = (error) => {
        console.error("reCAPTCHA Error:", error);
        setError("CAPTCHA verification failed. Please try again.");
        setIsLoading(false);
    };

    const handleCaptchaExpired = () => {
        console.log("reCAPTCHA expired");
        if (recaptchaRef.current) {
            recaptchaRef.current.reset();
        }
    };

    const validateForm = () => {
        if (userId === "") {
            setError("Enter UserId");
            return false;
        }
        else if (password === "") {
            setError("Enter Password");
            return false;
        }
        else if (showOtpField && otp === "") {
            setError("Enter OTP");
            return false;
        }
        else if (showOtpField && !otpValidated) {
            setError("Please verify OTP first");
            return false;
        }
        else {
            setError("");
            return true;
        }
    };

    const handleForgotPasswordClick = () => {
        setShowForgotPassword(true);
    };

    const handleValidateOtp = () => {
        if (otp === "") {
            setError("Enter OTP");
            return;
        }

        setIsLoading(true);
        const postData = {
            userId: userId,
            otp: otp,
        };

        callingAPIWithoutAuth(postData, "user/validateOTP", 'post')
            .then((response) => {
                console.log("🚀 ~ .then ~ response:", response);
                const { data } = response;
                if (data.statusCode === 200) {
                    setError(data.message);
                    setOtpValidated(true);
                    // Use acceptTermsAndCondition from login API state
                    if (acceptTermsAndCondition === "Yes") {
                        dispatch(
                            setDashboardData({
                                previousPage: 10,
                            })
                        );
                        navigate("/dashboard", { state: { directFlag: true } });
                    } else {
                        handleOpenTermsModal();
                    }
                } else {
                    setError(data.message);
                    setOtpValidated(false);
                }
            })
            .catch((error) => {
                console.error("API call error:", error.response || error);
                setError(error.response?.data?.message || "An error occurred during OTP validation");
                setOtpValidated(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const login = async () => {
        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        setError("");

        try {
            // Reset reCAPTCHA before executing
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }

            // Execute reCAPTCHA with timeout handling
            const token = await Promise.race([
                recaptchaRef.current?.executeAsync(),
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('reCAPTCHA timeout')), 30000)
                )
            ]);

            if (!token) {
                throw new Error("CAPTCHA verification failed. Please try again.");
            }

            const postData = {
                userId,
                password,
                recaptchaToken: token,
            };

            const response = await callingAPIWithoutAuth(postData, "user/login", 'post');
            const { data } = response;

            if (data.statusCode === 200) {
                const clientid = data.data[0].clientid;
                const clientname = data.data[0].clientname
                const userId = data.data[0].userId
                const hasMarket = data.data[0].hasMarket
                const passwordExpired = data.data[0].isPasswordExpired
                const marginFlag = data.data[0].marginflag
                const acceptTermsAndConditionApi = data.data[0].acceptTermsAndCondition
                setAcceptTermsAndCondition(acceptTermsAndConditionApi); // store for OTP flow
                const jwtToken = data.data[0].userSession.accessToken
                const refreshToken = data.data[0].userSession.refreshToken
                const isHumanResp = data.data[0].isHuman
                window.sessionStorage.setItem("accessToken", jwtToken);
                window.sessionStorage.setItem("refreshToken", refreshToken);
                dispatch(
                    setDashboardData({
                        initialClientid: clientid,
                        clientid: clientid,
                        clientname: clientname,
                        userId: userId,
                        reportValue: "Dashboard",
                        hasMarket: hasMarket,
                        passwordExpired: passwordExpired,
                        marginFlag: marginFlag,
                        jwtToken: jwtToken,
                        refreshToken: refreshToken,
                        externalAPI: true,
                        isHuman: isHumanResp
                    })
                );

                if (isHumanResp === false) {
                    console.log("🚀 ~ login ~ isHumanResp1:", isHumanResp)
                    setShowOtpField(true);

                }
                else if (passwordExpired === "1") {
                    navigate('/change-password');
                }
                else {
                    if (acceptTermsAndConditionApi === "Yes") {
                        dispatch(
                            setDashboardData({
                                previousPage: 10,
                            })
                        );
                        navigate("/dashboard", { state: { directFlag: true } });
                    }
                    else {
                        handleOpenTermsModal();
                    }
                }
            } else {
                console.error('Login failed with status code:', data.statusCode);
                setError(data.message);
            }
        } catch (error) {
            console.error('Login error:', error);

            if (error.message === 'reCAPTCHA timeout') {
                setError("CAPTCHA verification timed out. Please try again.");
            } else if (error && error.response && error.response.data) {
                const { message } = error.response.data;
                setError(message);
            } else if (error && error.message) {
                setError(error.message);
            } else {
                setError("An unknown error occurred. Please try again.");
            }

            // Reset reCAPTCHA on error
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
        } finally {
            setIsLoading(false);
        }
    };


    const handleOpenTermsModal = () => {
        setIsTermsServiceModalOpen(true);
    };

    const handleCloseTermsModal = () => {
        dispatch(clearDashboardData());
        navigate('/');
        setIsTermsServiceModalOpen(false);
    };

    const handleConfirmTermsModal = (isCheckboxChecked) => {
        if (isCheckboxChecked) {
            const postData = {
                userId: userId
            };
            callingAPIWithoutAuth(postData, "user/acceptTermsAndCondition", 'post')
                .then((response) => {
                    const { data } = response;
                    if (data.statusCode === 200) {
                        setIsTermsServiceModalOpen(false);
                        dispatch(
                            setDashboardData({
                                previousPage: 10,
                            })
                        );
                        navigate("/dashboard", { state: { directFlag: true } });
                    }
                })
                .catch((error) => {
                    console.error("Error accepting terms:", error);
                });
        } else {
            setShowErrorMsg(true);
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-division">
                <div className="login-left">
                    <div className="login-grad-img position-relative">
                        <div className="login-shape-img">
                            <img src={Shape} alt="Shape" className="img-fluid" width="200" height="200" />
                        </div>
                        <div className="login-text">
                            Secure. Simple. Invested.
                        </div>
                    </div>
                </div>
                <div className="login-right">
                    <div className="logo-img pt-5">
                        <img src={Logo} alt="Logo" className="img-fluid" width="200" height="200" />
                    </div>
                    {showForgotPassword ? (
                        <ForgotPassword setShowForgotPassword={setShowForgotPassword} />
                    ) : (
                        <>
                            <div className="login-form-wrap">
                                <h1 className="login-head">Login</h1>
                                <p className="login-para">
                                    Welcome to Al Mal Capital, Please enter your login details below to use the app.
                                </p>
                                <div className="col-12 position-relative">
                                    <div className="d-flex justify-content-center">
                                        {error && <p className="err-msg-text">{error}</p>}
                                    </div>
                                    <div className="form-labels-outer">
                                        <label htmlFor="userId" className="form-label">User ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter User ID"
                                            value={userId}
                                            onChange={(e) => setUserId(e.target.value)}
                                            onPaste={(e) => e.preventDefault()}
                                            onCopy={(e) => e.preventDefault()}
                                            onCut={(e) => e.preventDefault()}
                                            onDrop={(e) => e.preventDefault()}
                                            onDragStart={(e) => e.preventDefault()}
                                            onKeyDown={(e) => {
                                                if (e.ctrlKey || e.metaKey) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            disabled={isLoading}
                                        />
                                    </div>
                                    <div className="form-labels-outer mb-0">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <div className="Right-Icon">
                                            <input
                                                type={isPasswordVisible ? 'text' : 'password'}
                                                className="form-control"
                                                placeholder="Enter Password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                onPaste={(e) => e.preventDefault()}
                                                onCopy={(e) => e.preventDefault()}
                                                onCut={(e) => e.preventDefault()}
                                                onDrop={(e) => e.preventDefault()}
                                                onDragStart={(e) => e.preventDefault()}
                                                onKeyDown={(e) => {
                                                    if (e.ctrlKey || e.metaKey) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                disabled={isLoading}
                                            />
                                            <div className="eye-show" onClick={togglePasswordVisibility}>
                                                <img
                                                    src={isPasswordVisible ? HideEye : Eye}
                                                    alt="Toggle Password Visibility"
                                                    className="img-fluid"
                                                    width="15"
                                                    height="15"
                                                />
                                            </div>
                                        </div>
                                        <div className="forgot-pass-sec">
                                            <a className="forgot-passtext" onClick={handleForgotPasswordClick}>Forgot Password?</a>
                                        </div>

                                        {showOtpField && (
                                            <div className="form-labels-outer">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter OTP"
                                                    value={otp}
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    maxLength="6"
                                                    onPaste={(e) => e.preventDefault()}
                                                    onCopy={(e) => e.preventDefault()}
                                                    onCut={(e) => e.preventDefault()}
                                                    onDrop={(e) => e.preventDefault()}
                                                    onDragStart={(e) => e.preventDefault()}
                                                    onKeyDown={(e) => {
                                                        if (e.ctrlKey || e.metaKey) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    disabled={isLoading}
                                                />
                                                <div className="otp-hint-text mt-2">

                                                    <small style={{ color: '#28a745', fontSize: '12px', display: 'block' }}>
                                                        ✓ OTP has been sent to your registered mobile number
                                                    </small>

                                                    {otpValidated && (
                                                        <small style={{ color: '#28a745', fontSize: '12px', display: 'block' }}>
                                                            ✓ OTP verified successfully
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div className="w-100 mb-1">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                                size="invisible"
                                                badge="bottomright"
                                                onError={handleCaptchaError}
                                                onExpired={handleCaptchaExpired}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        {showOtpField ? (
                                            <button
                                                className="btn btn-login btn-block"
                                                onClick={handleValidateOtp}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Verifying..." : "Verify OTP"}
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-login btn-block"
                                                onClick={login}
                                                disabled={isLoading}
                                            >
                                                {isLoading ? "Logging in..." : "Login"}
                                            </button>
                                        )}
                                    </div>

                                    <div className="bottom-text">
                                        <a href="/terms-and-conditions" className="link-item">Terms of Service</a>
                                        <a href="/privacy-policy" className="link-item">Privacy Policy</a>
                                        <a href="/risk-and-disclosure" className="link-item">Risk Disclosure</a>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            <TermsServicePopup
                isOpen={isTermsServiceModalOpen}
                onClose={handleCloseTermsModal}
                onConfirm={handleConfirmTermsModal}
                showErrorMsg={showErrorMsg}
                setShowErrorMsg={setShowErrorMsg}
            />
        </div>
    )
}